import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { OrderEntry } from '../../../../core/model';

@Injectable({
  providedIn: 'root',
})
export class CartEntryReamingConnector {
  constructor(private httpClient: HttpClient, private occEndpointsService: OccEndpointsService) {}

  add(userId: string, cartId: string, entry: OrderEntry): Observable<any> {
    const url = this.occEndpointsService.buildUrl('cartEntryReaming', {
      urlParams: {
        userId: userId,
        cartCodeOrType: cartId,
        entryNumber: `${entry.entryNumber}`,
      },
    });
    return this.httpClient.put(url, null);
  }

  remove(userId: string, cartId: string, entry: OrderEntry): Observable<any> {
    const url = this.occEndpointsService.buildUrl('cartEntryReaming', {
      urlParams: {
        userId: userId,
        cartCodeOrType: cartId,
        entryNumber: `${entry.entryNumber}`,
      },
    });
    return this.httpClient.delete(url);
  }
}
